import React from "react";
import { FaHistory } from "react-icons/fa";

const OldThemeLogo = () => <FaHistory color="black" size={"40px"} />;

export default OldThemeLogo;